import axios from 'axios';

export function deletePreference(data) {
    return axios({
        method: 'DELETE',
        url: `/api/v1/admin/preferences/${data._id}`,
        withCredentials: true,
    })
        .then(response => response)
        .catch(errors => errors.response);
}

export function getPreference(data) {
    return axios({
        method: 'GET',
        url: `/api/v1/admin/preferences/${data._id}`,
        withCredentials: true,
    })
        .then(response => response)
        .catch(errors => errors.response);
}

export function updatePreference(data, _id) {
    return axios({
        method: 'PUT',
        url: `/api/v1/admin/preferences/${_id}`,
        withCredentials: true,
        data,
    })
        .then(response => response)
        .catch(errors => errors.response);
}

export function updatePreferenceMeta(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/admin/preferences/${data._id}/meta`,
        withCredentials: true,
        data,
    })
        .then(response => response)
        .catch(errors => errors.response);
}

export function getPreferences(data) {
    return axios({
        method: 'GET',
        url: `/api/v1/admin/preferences/byType/${data.type}`,
        withCredentials: true,
    })
        .then(response => response)
        .catch(errors => errors.response);
}



// WEBPACK FOOTER //
// ./app/services/preferences/index.js